import { cn } from '@/lib/utils';

/**
 * What to know before restoring a snapshot, one warning per line, as the
 * gateway's dry run said it: a change that may cut the device off from its
 * controller, or a setting a restore can't remove. Shown before anything runs.
 */
export function RestoreWarnings({ warnings, className }: { warnings: string; className?: string }) {
  return (
    <div className={cn('rounded-md border border-sev-3 bg-sev-3-soft p-2 text-xs space-y-1', className)}>
      {warnings.split('\n').map((warning, i) => (
        <p key={i}>{warning}</p>
      ))}
    </div>
  );
}
